/** @format — Shared illustration empty state (chat, shipments, etc.) */

import React from "react";
import { Button } from "@/components/ui/button";
import { car_illustration } from "@/assets";
import { cn } from "@/lib/utils";

type IllustrationEmptyStateProps = {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  loading?: boolean;
  className?: string;
  illustration?: string;
  illustrationAlt?: string;
};

export default function IllustrationEmptyState({
  title,
  description,
  actionLabel,
  onAction,
  loading = false,
  className = "",
  illustration = car_illustration,
  illustrationAlt = "",
}: IllustrationEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center px-4 py-10 text-center sm:px-6 sm:py-16",
        className,
      )}
    >
      <img
        src={illustration}
        alt={illustrationAlt}
        className="mb-5 h-auto w-[120px] max-w-full sm:mb-6 sm:w-[160px] md:w-[200px]"
        aria-hidden={!illustrationAlt}
      />
      <h2 className="mb-2 text-[15px] font-semibold text-[#1D2739] sm:text-[16px]">{title}</h2>
      {description ? (
        <p className="mb-6 max-w-[320px] text-[12px] leading-relaxed text-[#667185] sm:text-[13px]">
          {description}
        </p>
      ) : null}
      {onAction && actionLabel ? (
        <Button
          type="button"
          onClick={onAction}
          disabled={loading}
          className="h-10 rounded-full bg-[#2563EB] px-6 text-[14px] font-medium text-white shadow-none hover:bg-[#1C3BC7] active:scale-[0.98] active:bg-[#1C3BC7] md:h-8 md:min-h-8 md:px-3 md:py-1.5 md:text-[#FAFAFA]"
        >
          {loading ? (
            <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
          ) : (
            actionLabel
          )}
        </Button>
      ) : null}
    </div>
  );
}
